/**
 * Controller: GroupsRolesRemoveModal
 */
angular.module('acme.view.application.groups.roles.removeModal.controllers', [])
.controller('GroupsRolesRemoveModalController', [ '$scope', '$uibModalInstance', 'currentRole', function ($scope, $uibModalInstance, currentRole) {

    $scope.errors = [];

    $scope.model = {
      id: currentRole.id,
      name: currentRole.name,
      displayName: currentRole.displayName
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);